<section class="space-ptb" id="signin-form">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-8 col-lg-10 col-md-12">
          <div class="login-register">
            <div class="section-title">
             <h4 class="text-center">Login to Manzoul</h4>
            </div>
            <fieldset>
              <legend class="px-2">How do you want to login?</legend>
              <ul id="menu" class="nav nav-tabs nav-tabs-border d-flex" role="tablist">
                <li class="nav-item mr-4">
                  <a class="nav-link {{signInTypeStyles[0]}}" data-toggle="tab" (click)="signInTypeClicked('candidate')" role="tab" aria-selected="false">
                    <div class="d-flex">
                      <div class="tab-icon">
                        <i class="flaticon-users"></i>
                      </div>
                      <div class="ml-3">
                        <h6 class="mb-0">Candidate</h6>
                        <p class="mb-0">Log in as a candidate</p>
                      </div>
                    </div>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link {{signInTypeStyles[1]}}" data-toggle="tab" (click)="signInTypeClicked('employer')" role="tab" aria-selected="false">
                    <div class="d-flex">
                      <div class="tab-icon">
                        <i class="flaticon-suitcase"></i>
                      </div>
                      <div class="ml-3">
                        <h6 class="mb-0">Job Poster</h6>
                        <p class="mb-0">Log in as a job poster</p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </fieldset>
            <div class="tab-content">
              <div class="tab-pane active" id="signinForm" role="tabpanel">
                <form class="mt-4" [formGroup]="form">
                  <div class="form-row" *ngIf="errorMessage">
                    <div class="form-group col-12">
                      <div class="alert alert-danger alert-dismissible fade show" role="alert">
                        {{errorMessage}}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                          <span aria-hidden="true" (click)="onDismissError()">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-12">
                      <label for="Email2">Email Address*</label>
                      <input type="text" class="form-control" formControlName="username">
                    </div>
                    <div class="form-group col-12">
                      <label for="password2">Password*</label>
                      <input type="password" class="form-control" formControlName="password">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6">
                      <a class="btn btn-primary btn-block" [routerLink]="" (click)="signIn()">Sign In</a>
                    </div>
                    <div class="col-md-6">
                      <div class="ml-md-3 mt-3 mt-md-0 forgot-pass">
                        <a [routerLink]="['/forgot-password']">Forgot Password?</a>
                        <p class="mt-1">Don't have account? <a [routerLink]="" (click)="onSignupClicked()">Sign Up here</a></p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="mt-4">
              <fieldset>
                <legend class="px-2">Login or Sign up with</legend>
                <div class="social-login">
                  <ul class="list-unstyled d-flex mb-0">
                    <li class="google text-center">
                      <a role="button" [routerLink]="" (click)="googleSignIn()"> <i class="fab fa-google mr-4"></i>Login with Google</a>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
